const API_URL = 'https://api.cuts.ink'

export default API_URL